<div
  class="background-hero background-hero--teacher"
  [bgUrl]="hero"
  [default]="''"
></div>
<div
  class="background-hero background-hero--player"
  [bgUrl]="heroTeacher"
  [default]="''"
></div>
